import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { selectProductsBySkus } from '@client/product/redux/products/tile/redux';
import { ProductTileType } from 'b2b-common/core/product/api/ProductTile.types';

export const useProductTilesData = (skus: string[]): Record<string, RemoteRecord<ProductTileType>> => useSelector(
  (state: AppState) => selectProductsBySkus(state, skus),
);
